import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-quikpoll",
  "use": "icon-quikpoll-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-quikpoll\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-quikpoll</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-quikpoll_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-quikpoll_icon-quikpoll\">\n            <path d=\"M8.96,1.6 L8.96,8.96 L1.6,8.96 C1.8400012,7.0133236 2.6466598,5.3533402 4.02,3.98 C5.3933402,2.6066598 7.0399904,1.8133344 8.96,1.6 Z M11.08,1.6 C13.1600104,1.866668 14.899993,2.7933254 16.3,4.38 C17.700007,5.9666746 18.4,7.826656 18.4,9.96 C18.4,12.2800116 17.5800082,14.2666584 15.94,15.92 C14.2999918,17.5733416 12.3066784,18.4 9.96,18.4 C7.826656,18.4 5.9733412,17.700007 4.4,16.3 C2.8266588,14.899993 1.8933348,13.1466772 1.6,11.04 L10.08,11.04 C10.346668,11.04 10.579999,10.9466676 10.78,10.76 C10.980001,10.5733324 11.08,10.3333348 11.08,10.04 L11.08,1.6 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sprites/icon-quikpoll.svg
// module id = 2Ti/
// module chunks = 1